export enum PaymentStatus {
  Initiating = 'INITIATING',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Expired = 'EXPIRED',
}

export interface Payment {
  id: string;
  status: PaymentStatus;
  method: 'SWISH';
  methodData: Record<string, string>;
  failureCode?: string;
  failureReason?: string;
}

export interface InitiatePaymentResponse {
  id: string;
  paymentMethodData: Record<string, string>;
}
